import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'directories.filters-v2.delete-modal.title',
		defaultMessage: 'Delete {name}',
		description: 'Title for delete filter modal.',
	},
});
export default messages;
